import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Stack,
} from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import { LoginFormValues } from "./types";
import configStore from "../../stores/ConfigStore";

interface UserAgreementDialogProps {
  data: LoginFormValues | null;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onVerified: (data: LoginFormValues | null) => void;
}

const api = process.env.REACT_APP_API;

const UserAgreementDialog = ({
  data,
  isOpen,
  setIsOpen,
  onVerified,
}: UserAgreementDialogProps) => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = React.useState<boolean>(false);
  const [userAgreement, setUserAgreement] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (isOpen) {
      setAccepted(false);
      setLoading(true);
      fetch(`${api}/public/user-agreement/${configStore.currentLanguage}.html`)
        .then((res) => res.text())
        .then((html) => setUserAgreement(html))
        .catch(() => setError(t("error")))
        .finally(() => setLoading(false));
    }
  }, [isOpen]);

  const handleVerify = () => {
    onVerified(data);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="adminCaseItemDialog"
    >
      <DialogActions className="dialogActions">
        <Button onClick={() => setIsOpen(false)} color={"error"}>
          &times;
        </Button>
      </DialogActions>
      <DialogContent className={"pt pr pl pb"}>
        {loading ? (
          <Stack
            direction={"row"}
            justifyContent={"center"}
            alignItems={"center"}
            className={"pt pb"}
          >
            <CircularProgress />
          </Stack>
        ) : error ? (
          <Alert color="error" severity="error" className="mt">
            {t("error")}
          </Alert>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: userAgreement }}></div>
        )}
        <Stack direction={"row"} justifyContent={"space-between"}>
          {!error && (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    value={accepted}
                    onChange={() => setAccepted(!accepted)}
                  />
                }
                label={t("userAgreementAccept")}
              />
              <Button disabled={!accepted} onClick={handleVerify}>
                {t("register")}
              </Button>
            </>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default UserAgreementDialog;
